import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20anime%20style%20illustration%20with%20mysterious%20Japanese%20manga%20panels%20and%20glowing%20speech%20bubbles%20floating%20in%20a%20deep%20dark%20purple%20and%20crimson%20sky%2C%20falling%20cherry%20blossom%20petals%20with%20red%20glow%2C%20dramatic%20dark%20atmosphere%2C%20ethereal%20composition%20with%20ample%20copy%20space%20in%20center%2C%20dark%20anime%20aesthetic%20with%20warm%20red%20accent%20lights&width=1920&height=900&seq=hero-bg-manga-01-dark&orientation=landscape"
          alt="本子网站 - 二次元漫画世界"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/90 via-foreground-950/60 to-foreground-950"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-screen-2xl mx-auto text-center py-20 md:py-32">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight">
            {t('home.hero.title')}
          </h1>
          <p className="text-base md:text-lg text-background-200/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            {t('home.hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              {t('home.hero.cta')}
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-lg hover:bg-background-50/20 transition-all text-sm whitespace-nowrap cursor-pointer border border-background-700"
            >
              {t('home.hero.browse')}
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
            {[
              { value: '500,000+', label: '注册用户' },
              { value: '5,000+', label: '漫画作品' },
              { value: '99.9%', label: '高清画质' },
              { value: '24/7', label: '随时阅读' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-400 font-semibold">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-300/60 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}